import { useApp } from "../context/AppContext";
import SearchView from "../views/SearchView";

export default function SearchPage() {
  const ctx = useApp();
  return (
    <SearchView
      query={ctx.query} results={ctx.results} searched={ctx.searched}
      selectedResults={ctx.selectedResults} toggleSelectResult={ctx.toggleSelectResult}
      handleBulkDownload={ctx.handleBulkDownload} handleBulkDelete={ctx.handleBulkDelete}
      activeTagFilter={ctx.activeTagFilter} setActiveTagFilter={ctx.setActiveTagFilter}
      token={ctx.token} activeFolderId={ctx.activeFolderId} folders={ctx.folders}
    />
  );
}